import { ProfileAPI } from '@/api';
import { IApiError } from '@/models/apiError.model';
import { IProfileResponse, IUpdateProfileDTO } from '@/models/profile.model';
import { formatApiError } from '@/utils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { PROFILE_SLICE_NAME } from './models';

export const getProfile = createAsyncThunk<IProfileResponse, void, { serializedErrorType: IApiError }>(
  `${PROFILE_SLICE_NAME}/getProfile`,
  async () => {
    const response = await ProfileAPI.getProfile();
    return response.data;
  },
  { serializeError: formatApiError },
);

export const updateProfile = createAsyncThunk<IProfileResponse, IUpdateProfileDTO, { serializedErrorType: IApiError }>(
  `${PROFILE_SLICE_NAME}/updateProfile`,
  async (data) => {
    const response = await ProfileAPI.updateProfile(data);
    return response.data;
  },
  { serializeError: formatApiError },
);
